import { createApp } from "vue";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import VueViewer from "v-viewer";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "normalize.css";
import "./less/index.less";
import "element-plus/dist/index.css";
import "viewerjs/dist/viewer.css";
import "@/utils/broadcast";

const app = createApp(App);
app
  .use(store)
  .use(router)
  .use(VueViewer, {
    defaultOptions: {
      zIndex: 9999,
    },
  })
  .mount("#app");
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
